import type { TaskWithAssignments } from '@scrambl/shared'
import { TaskStatusTypeEnum } from '@scrambl/shared'

/** Use the task's resolved status before falling back to legacy completion data. */
export function isTaskClosed(task: Partial<TaskWithAssignments>): boolean {
  const status = task.availableStatuses?.find(
    status => status.id === task.status,
  )
  const type = status?.statusTypeId ?? task.statusTypeId
  if (type) {
    return (
      type === TaskStatusTypeEnum.COMPLETED ||
      type === TaskStatusTypeEnum.CANCELED
    )
  }
  return (
    Boolean(task.completedAt) ||
    ['DONE', 'COMPLETED', 'CANCELED', 'CANCELLED'].includes(
      String(task.status).toUpperCase(),
    )
  )
}
